import api from "../services/api";

export const getVendorStats = (
  vendorId,
  groupId,
  productId,
  createdAfterDate,
  createdBeforeDate
) => {
  return new Promise((resolve, reject) => {
    api
      .get(
        `feedback/countandaveragescore?vendorId=${vendorId}&group=${groupId}&product=${productId}&createdAfter=${createdAfterDate}&createdBefore=${createdBeforeDate}`
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(`Error: ${error}`));
  });
};

export const getScoreStats = (
  vendorId,
  groupId,
  productId,
  createdAfterDate,
  createdBeforeDate
) => {
  return new Promise((resolve, reject) => {
    api
      .get(
        `feedback/scorestatistics?vendorId=${vendorId}&group=${groupId}&product=${productId}&createdAfter=${createdAfterDate}&createdBefore=${createdBeforeDate}`
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(`Error: ${error}`));
  });
};

export const getWithTextStats = (
  vendorId,
  group,
  product,
  createdAfterDate,
  createdBeforeDate
) => {
  return new Promise((resolve, reject) => {
    api
      .get(
        `feedback/withtext?vendorId=${vendorId}&group=${group}&product=${product}&createdAfter=${createdAfterDate}&createdBefore=${createdBeforeDate}`
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(`Error: ${error}`));
  });
};

export const getNPSScore = (
  vendorId,
  group,
  product,
  createdAfterDate,
  createdBeforeDate
) => {
  return new Promise((resolve, reject) => {
    api
      .get(
        `feedback/npsscore?vendorId=${vendorId}&group=${group}&product=${product}&createdAfter=${createdAfterDate}&createdBefore=${createdBeforeDate}`
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(`Error: ${error}`));
  });
};

export const getDetailedRatings = (
  vendorId,
  group,
  product,
  createdAfterDate,
  createdBeforeDate
) => {
  return new Promise((resolve, reject) => {
    api
      .get(
        `feedback/detailedratings?vendorId=${vendorId}&group=${group}&product=${product}&createdAfter=${createdAfterDate}&createdBefore=${createdBeforeDate}`
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(`Error: ${error}`));
  });
};

export const gethighestRatings = (
  vendorId,
  group,
  product,
  createdAfterDate,
  createdBeforeDate
) => {
  return new Promise((resolve, reject) => {
    api
      .get(
        `feedback/highestratings?vendorId=${vendorId}&group=${group}&product=${product}&createdAfter=${createdAfterDate}&createdBefore=${createdBeforeDate}`
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(`Error: ${error}`));
  });
};

export const getForTable = (
  group,
  product,
  createdAfterDate,
  createdBeforeDate
) => {
  return new Promise((resolve, reject) => {
    api
      .get(
        `feedback/forTable?&groupId=${group}&product=${product}&createdAfter=${createdAfterDate}&createdBefore=${createdBeforeDate}&lng=SL`
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(`Error: ${error}`));
  });
};
